import React from 'react';
import { WorkPageLayout } from '../Layout';
import styles from './Tools.module.scss';

export const ToolsStepFive = () => (
  <WorkPageLayout
    leftContent={
      <div className={styles.toolsLeftSection}>
        <span className={styles.toolsStepLeft_1}>TransparenTerra’s</span>
        <span className={styles.toolsStepLeft_2}>Tools</span>
        <span className={styles.toolsStepLeft_3}>and</span>
        <span className={styles.toolsStepLeft_4}>principles</span>
      </div>
    }
    rightContent={
      <div className={styles.toolsStepContentWrapper}>
        <p style={{ marginBottom: 40 }}>
          <div style={{ marginBottom: 8, fontWeight: 600 }}>TT chat</div>
          Dedicated chat with note-taking capabilities, an interactive whiteboard, and other
          features will make your consultations with experts as convenient and efficient as
          possible.
        </p>
        <p>
          <div style={{ marginBottom: 8, fontWeight: 600 }}>Blockchain Notarization</div>
          Digital interactions require heightened security. TransparenTerra provides tools for
          signing and storing contracts and verifying them through blockchain.
        </p>
      </div>
    }
  />
);
